import SettingList from '@/component/point/point-list/SettingList';

export default function PointSettingList() {
  return (
    <>
      <SettingList />
    </>
  );
}
